module.exports = __webpack_public_path__ + "static/media/news-3.8f5cfa24.jpg";